import { dispatch } from 'nike-re-framejs';

import { useInterval } from 'nike-ui/src/common/hooks/useInterval';
import { refreshBoxes } from '@/nikeone/handlers';

function useRefreshBoxes(boxStore) {
    useInterval(() => {
        dispatch(refreshBoxes(boxStore));
    }, 60 * 1000);
}

export default useRefreshBoxes;
